import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux';
import { store } from './store/store';
import './assets/styles/tailwind.scss'
import { App } from './App';
import { SnackbarProvider } from 'notistack';
import  reportWebVitals from './reportWebVitals';
import Loading from './components/templates/misc/loading/Loading';

if (process.env.NODE_ENV === 'production') {
  console.log = () => { };
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.Suspense fallback={<Loading />}>
    <Provider store={store}>
      <SnackbarProvider maxSnack={3}>
        <App />
      </SnackbarProvider>
    </Provider>
  </React.Suspense>
)
 
reportWebVitals()
